import { TFunction } from 'i18next'

import { TYPE_AGE } from 'shared/constants'
import { AllIcons } from 'shared/ui/app-icon/types.ts'

import { useAppealPassengerText } from '../ui/appeal-details/libs/getAppealPassengerText'
import type { AppealTabItem } from '../ui/appeal-details/types'

export interface AppealTabsDataMinimal {
  hotel: {
    hotel_name?: string
    tours?: Array<{ room_info?: { name?: string } }>
    operator?: string
  }
  personal_data: {
    [TYPE_AGE.ADULTS]: unknown[]
    [TYPE_AGE.CHILDREN]: unknown[]
  }
}

interface GetAppealTabsProps {
  t: TFunction
  appealDetails: AppealTabsDataMinimal
  handleMoreHotelDetails?: () => void
  handleMorePurchaseDetails?: () => void
}

export const getAppealTabs = ({
  t,
  appealDetails,
  handleMoreHotelDetails,
  handleMorePurchaseDetails,
}: GetAppealTabsProps): AppealTabItem[] => {
  const { hotel, personal_data } = appealDetails

  const hotelText = `${hotel?.hotel_name}, ${hotel?.tours?.[0]?.room_info?.name},
  ${t('tours_block.operator', { operator: hotel?.operator })}`

  const passengersText = useAppealPassengerText({
    adults: personal_data[TYPE_AGE.ADULTS]?.length ?? 0,
    children: personal_data[TYPE_AGE.CHILDREN]?.length ?? 0,
    t,
  })

  return [
    {
      key: 1,
      name: 'tours_block.hotel_and_room',
      subtitle: hotelText,
      icon: AllIcons.HOTEL,
      ...(handleMoreHotelDetails && { onClick: handleMoreHotelDetails }),
    },
    {
      key: 2,
      name: 'tours_block.tourists',
      subtitle: passengersText,
      icon: AllIcons.PASSENGERS_TRIO,
      ...(handleMorePurchaseDetails && { onClick: handleMorePurchaseDetails }),
    },
  ]
}
